// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var ref = allVue.ref;
var inject = allVue.inject;
import { classNames, Icon } from '@progress/kendo-vue-common';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { ProgressBar } from '@progress/kendo-vue-progressbars';
import { messages, statusUploaded, statusUploadFailed } from './messages/main';
import utils from './utils/utils';
import { UploadListActionButton } from './UploadListActionButton';
import { fileAudioIcon, fileConfigIcon, fileDataIcon, fileIcon, fileImageIcon, filePdfIcon, filePresentationIcon, fileProgrammingIcon, fileTxtIcon, fileVideoIcon, fileZipIcon } from '@progress/kendo-svg-icons';
/**
 * @hidden
 */
var UploadListSingleItemVue2 = {
  name: 'KendoVueUploadListSingleItem',
  props: {
    files: Array,
    disabled: Boolean,
    async: Object
  },
  // @ts-ignore
  emits: {
    'cancel': null,
    'retry': null,
    'remove': null
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  methods: {
    onRetry: function onRetry(uid) {
      this.$emit('retry', uid);
    },
    onRemove: function onRemove(uid) {
      this.$emit('remove', uid);
    },
    onCancel: function onCancel(uid) {
      this.$emit('cancel', uid);
    },
    getFileExtension: function getFileExtension(file) {
      return file.extension ? file.extension.substring(1) : '';
    },
    getFileValidationMessage: function getFileValidationMessage(file, isUploadFailed) {
      var localizationService = provideLocalizationService(this);
      var validationMessage = '';
      if (isUploadFailed) {
        validationMessage = localizationService.toLanguageString(statusUploadFailed, messages[statusUploadFailed]);
      } else if (file.validationErrors && file.validationErrors.length > 0) {
        var messageKey = "upload.".concat(file.validationErrors[0]);
        validationMessage = localizationService.toLanguageString(messageKey, messages[messageKey]);
      }
      return validationMessage;
    },
    getFileExtensionName: function getFileExtensionName(file) {
      switch (file.extension) {
        case '.png':
        case '.jpg':
        case '.jpeg':
        case '.tiff':
        case '.bmp':
        case '.gif':
          return 'file-image';
        case '.mp3':
        case '.mp4':
        case '.wav':
          return 'file-audio';
        case '.mkv':
        case '.webm':
        case '.flv':
        case '.gifv':
        case '.avi':
        case '.wmv':
          return 'file-video';
        case '.txt':
          return 'file-txt';
        case '.pdf':
          return 'file-pdf';
        case '.ppt':
        case '.pptx':
          return 'file-presentation';
        case '.csv':
        case '.xls':
        case '.xlsx':
          return 'file-data';
        case '.html':
        case '.css':
        case '.js':
        case '.ts':
          return 'file-programming';
        case '.exe':
          return 'file-config';
        case '.zip':
        case '.rar':
          return 'file-zip';
        default:
          return 'file';
      }
    },
    getFileExtensionSVG: function getFileExtensionSVG(file) {
      switch (file.extension) {
        case '.png':
        case '.jpg':
        case '.jpeg':
        case '.tiff':
        case '.bmp':
        case '.gif':
          return fileImageIcon;
        case '.mp3':
        case '.mp4':
        case '.wav':
          return fileAudioIcon;
        case '.mkv':
        case '.webm':
        case '.flv':
        case '.gifv':
        case '.avi':
        case '.wmv':
          return fileVideoIcon;
        case '.txt':
          return fileTxtIcon;
        case '.pdf':
          return filePdfIcon;
        case '.ppt':
        case '.pptx':
          return filePresentationIcon;
        case '.csv':
        case '.xls':
        case '.xlsx':
          return fileDataIcon;
        case '.html':
        case '.css':
        case '.js':
        case '.ts':
          return fileProgrammingIcon;
        case '.exe':
          return fileConfigIcon;
        case '.zip':
        case '.rar':
          return fileZipIcon;
        default:
          return fileIcon;
      }
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      files = _a.files,
      disabled = _a.disabled,
      async = _a.async;
    var file = files[0];
    var itemClassName = classNames('k-file-single');
    var _b = utils.getFileStatus([file]),
      isUploaded = _b[1],
      isUploadFailed = _b[2],
      isUploadValidationFailed = _b[3];
    var showProgressBar = !isUploadValidationFailed && !isUploaded && !isUploadFailed;
    var renderValidationError = function renderValidationError(currentFile, isCurrentUploadFailed) {
      return h("span", {
        "class": 'k-file-info',
        key: '2'
      }, [h("span", {
        "class": 'k-file-name',
        title: currentFile.name,
        attrs: this.v3 ? undefined : {
          title: currentFile.name
        }
      }, [currentFile.name]), h("span", {
        "class": 'k-file-validation-message'
      }, [this.getFileValidationMessage(currentFile, isCurrentUploadFailed)])]);
    };
    var renderFileDetails = function renderFileDetails(currentFile) {
      var localizationService = provideLocalizationService(this);
      var successMessage = localizationService.toLanguageString(statusUploaded, messages[statusUploaded]);
      return h("span", {
        "class": 'k-file-info',
        key: '2'
      }, [h("span", {
        "class": 'k-file-name',
        title: currentFile.name,
        attrs: this.v3 ? undefined : {
          title: currentFile.name
        }
      }, [currentFile.name]), currentFile.progress !== 100 ? h("span", {
        "class": 'k-file-size'
      }, [utils.getTotalFilesSizeMessage([currentFile])]) : h("span", {
        "class": 'k-file-validation-message'
      }, [successMessage])]);
    };
    return h("div", {
      "class": itemClassName
    }, [showProgressBar && h(ProgressBar, {
      value: file.progress || 0,
      attrs: this.v3 ? undefined : {
        value: file.progress || 0,
        labelVisible: false
      },
      labelVisible: false
    }), h("span", {
      "class": 'k-file-icon-wrapper',
      key: '1'
    }, [h(Icon, {
      name: this.getFileExtensionName(file),
      attrs: this.v3 ? undefined : {
        name: this.getFileExtensionName(file),
        icon: this.getFileExtensionSVG(file),
        size: 'xxxlarge'
      },
      icon: this.getFileExtensionSVG(file),
      size: 'xxxlarge',
      "class": 'k-file-icon'
    }), h("span", {
      "class": 'k-file-state'
    })]), isUploadValidationFailed || isUploadFailed ? renderValidationError.call(this, file, isUploadFailed) : renderFileDetails.call(this, file),
    // @ts-ignore  function children
    h(UploadListActionButton, {
      uid: file.uid,
      attrs: this.v3 ? undefined : {
        uid: file.uid,
        status: file.status,
        progress: file.progress,
        files: files,
        disabled: disabled,
        async: async
      },
      status: file.status,
      progress: file.progress,
      files: files,
      disabled: disabled,
      async: async,
      onCancel: this.onCancel,
      on: this.v3 ? undefined : {
        "cancel": this.onCancel,
        "remove": this.onRemove,
        "retry": this.onRetry
      },
      onRemove: this.onRemove,
      onRetry: this.onRetry
    })]);
  }
};
/**
 * @hidden
 */
var UploadListSingleItem = UploadListSingleItemVue2;
export { UploadListSingleItem, UploadListSingleItemVue2 };